import React from "react";

// ── PropertyImagePlaceholder ─────────────────────────────────────────────────────
// Generic fallback shown wherever a property/unit has no image. Renders a house
// icon on a neutral background, sized to fill its container so it can drop in place
// of an <img>. Icon and label scale down for small thumbnails.
const PropertyImagePlaceholder = ({
  height = 140,
  width = "100%",
  borderRadius = 0,
  small = false,
  label = "No image",
  showLabel = true,
}) => {
  const iconSize = small ? 20 : Math.min(64, Math.max(28, Number.isFinite(height) ? height * 0.4 : 48));

  return (
    <div
      style={{
        width,
        height,
        borderRadius,
        background: "#f3f4f6",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: small ? 2 : 6,
        color: "#9ca3af",
      }}
      aria-label={label}
      role="img"
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {/* House outline with roof */}
        <path d="M3 10.5 12 3l9 7.5" />
        <path d="M5 9.5V21h14V9.5" />
        {/* Door */}
        <path d="M10 21v-6h4v6" />
      </svg>
      {showLabel && !small && (
        <span style={{ fontSize: 12, fontWeight: 500 }}>{label}</span>
      )}
    </div>
  );
};

export default PropertyImagePlaceholder;
